<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">
        成交汇总查询
        <TopPartner @refreshTopPartner="handleSearch"></TopPartner>
      </div>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input placeholder="用户UID" clearable v-model="userId">
              </el-input>
            </div>
          </div>
          <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div> -->
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">时间</div> -->
            <div class="ipt">
              <el-date-picker
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime($event)"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="small" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="small" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <div class="item-sle">
              <div class="tit">特殊账号</div>
              <el-select size="small" v-model="type" placeholder="特殊账号">
                <el-option
                  v-for="item in [
                    { id: 1, value: '隐藏' },
                    { id: 2, value: '显示' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="d-item">
          <span>总结算盈亏： </span>
          <span>{{ detailList.profit }}</span>
          <span>USDT</span>
        </div>
        <div class="d-item">
          <span>总手续费：</span>
          <span>{{ detailList.fee }} </span>
          <span>USDT</span>
        </div>
        <div class="d-item">
          <span>总净盈亏：</span>
          <span>{{ detailList.purenessProfit }} </span>
          <span>USDT</span>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";
import TopPartner from "../topPartner";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "transcationSummary",
  components: {
    UserList,
    TopPartner,
  },
  data() {
    return {
      tenantList: [],
      tenantId: "",
      value2: "",
      dialogVisible: false,
      userId: "",
      channelId: "",
      channelUserId: "",
      inviteBy: "",
      type: 1,
      value1: "",
      // value1: [

      // moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     "-" +
      //     (new Date().getMonth() + 1) +
      //     "-" +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("transcationSummary", [
      "queryType",
      "detailList",
      "pagination",
    ]),
    ...mapState(["userInfo"]),
    ...mapState("topPartner", ["topPartner"]),
  },
  methods: {
    ...mapActions("transcationSummary", ["list", "getDetail"]),
    ...mapMutations("transcationSummary", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
        ...this.pagination,
        ...data,
      });
    },
    changeTime(e) {
      this.getDetail({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        startTime: e[0],
        endTime: e[1],
        tenantId: this.tenantId,
      });
      this.list({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        startTime: e[0],
        endTime: e[1],
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.getDetail({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
      });
      this.list({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.getDetail({
      channelId: this.topPartner,
      channelUserId: this.channelUserId,
      userId: this.userId,
      type: this.type,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      tenantId: this.tenantId,
    });
    this.list({
      channelId: this.topPartner,
      channelUserId: this.channelUserId,
      userId: this.userId,
      type: this.type,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      tenantId: this.tenantId,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
<style lang="less" scoped>
.detail {
  display: flex;
  padding: 0 !important;
  margin: 0 !important;
  .d-item {
    margin-right: 16px;
    padding: 0 !important;
    display: flex;
    align-items: center;
    font-family: PingFangSC-Medium, PingFang SC;

    span {
      &:first-child {
        font-size: 18px;
        font-weight: 500;
        color: #0e1337;
      }
      &:nth-child(2) {
        font-size: 18px;
        font-weight: 600;
        color: #ff7e0c;
        line-height: 25px;
        margin-left: 12px;
        margin-right: 4px;
      }
      &:last-child {
        font-size: 14px;
        font-weight: 500;
        color: #ff7e0c;
        line-height: 20px;
      }
    }
    &:nth-child(1) {
      padding-left: 0;
    }
  }
}
</style>
